import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

interface EditionHeaderProps {
  edition: string;
  productType?: 'Pulse' | 'Pulse X';
  height?: number | string;
}

const EditionHeader: React.FC<EditionHeaderProps> = ({ edition, productType = 'Pulse', height = 200 }) => {
  const [imageError, setImageError] = useState(false);
  
  if (!edition || edition === 'All Editions') {
    return null;
  }

  // Determine if we need to use jpg or png based on the edition
  const getImageExtension = (edition: string) => {
    if (edition === 'Halloween Edition' || edition === 'Sour Edition') {
      return '.jpg';
    }
    return '.png';
  };
  
  // Construct the image path for the header based on product type and edition
  const extension = getImageExtension(edition);
  // Use process.env.PUBLIC_URL to get the correct base URL for GitHub Pages
  const baseUrl = process.env.PUBLIC_URL || '';
  const imagePath = `${baseUrl}/images/${productType}/${edition}/header${extension}`;
  
  const handleImageError = () => {
    console.error(`Failed to load header image: ${imagePath}`);
    setImageError(true);
  };
  
  return (
    <Box
      sx={{
        height,
        width: '100%',
        marginBottom: 3,
        borderRadius: 2,
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      {!imageError ? (
        <img 
          src={imagePath}
          alt={`${edition} header`}
          style={{ 
            maxWidth: '100%', 
            maxHeight: '100%', 
            objectFit: 'contain',
          }}
          onError={handleImageError}
        />
      ) : (
        <Typography 
          variant="h4" 
          component="div" 
          sx={{ 
            textAlign: 'center',
            padding: 2,
          }}
        >
          {edition}
        </Typography>
      )}
      
      {/* Product type badge */}
      <Box
        sx={{
          position: 'absolute',
          top: 16,
          left: 16,
          backgroundColor: productType === 'Pulse' ? 'primary.main' : 'secondary.main',
          color: 'white',
          padding: '4px 12px',
          borderRadius: '16px',
          fontWeight: 'bold',
          fontSize: '0.875rem',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
        }}
      >
        {productType}
      </Box>
    </Box>
  );
};

export default EditionHeader;
